import { ApiError } from '@anm/api';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';

import { AppSumoSignUpData, CouponCodes } from './types';

export const checkCoupon = createAction('wave.video/appSumo/CHECK_COUPON')<string>();
export const checkCouponAsync = createAsyncAction(
  'wave.video/appSumo/CHECK_COUPON_REQUEST',
  'wave.video/appSumo/CHECK_COUPON_SUCCESS',
  'wave.video/appSumo/CHECK_COUPON_ERROR'
)<string, string, ApiError>();

export const activateCoupon = createAction('wave.video/appSumo/ACTIVATE_COUPON')<CouponCodes>();
export const activateCouponWithRedirect = createAction('wave.video/appSumo/ACTIVATE_COUPON_WITH_REDIRECT')<
  CouponCodes
>();
export const activateCouponAsync = createAsyncAction(
  'wave.video/appSumo/ACTIVATE_COUPON_REQUEST',
  'wave.video/appSumo/ACTIVATE_COUPON_SUCCESS',
  'wave.video/appSumo/ACTIVATE_COUPON_ERROR'
)<string, string, ApiError>();

export const signupAppSumo = createAction('wave.video/appSumo/SIGNUP_APP_SUMO')<AppSumoSignUpData>();

export const upgrade = createAction('wave.video/appSumo/UPGRADE')();
export const upgradeAsync = createAsyncAction(
  'wave.video/appSumo/UPGRADE_REQUEST',
  'wave.video/appSumo/UPGRADE_SUCCESS',
  'wave.video/appSumo/UPGRADE_ERROR'
)<string, string, ApiError>();

export const changeRedirectPending = createAction('wave.video/appSumo/CHANGE_REDIRECT_PENDING_STATUS')<boolean>();
